var map = {
	"./3dc-white.png": "1bd1",
	"./3dc.png": "b4a6",
	"./MechD-white.png": "8ae5",
	"./MechD.png": "2fe8",
	"./SUTD-Productions-Logo-white.png": "8474",
	"./SUTD-Productions-Logo.png": "376c",
	"./accenture-white.png": "62bf",
	"./accenture.png": "25f5",
	"./aws-white.png": "149f",
	"./aws.png": "63db",
	"./bamboo-builders-white.png": "1221",
	"./bamboo-builders.png": "4513",
	"./bands-white.png": "5fa7",
	"./bands.png": "8e82",
	"./climatescience-white.png": "fb52",
	"./climatescience.png": "b617",
	"./energy-white.png": "c68a",
	"./energy.png": "b249",
	"./google-white.png": "7e83",
	"./google.png": "bf60",
	"./govtech-white.png": "47b0",
	"./govtech.png": "db72",
	"./greenprint-white.png": "715a",
	"./greenprint.png": "4484",
	"./ieee-white.png": "8650",
	"./ieee.png": "b0a2",
	"./imda-white.png": "e00b",
	"./imda.png": "16bf",
	"./indeed-white.png": "627c",
	"./indeed.png": "f5e5",
	"./istd-white.png": "e6cd",
	"./istd.png": "ebd9",
	"./lionhearter-white.png": "da9c",
	"./lionhearter.png": "cebb",
	"./makerspace-white.png": "6c75",
	"./makerspace.png": "b0a4",
	"./ncs-white.png": "680d",
	"./ncs.png": "c189",
	"./photog-white.png": "0b24",
	"./photog.png": "802c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "59b9";